/* eslint-disable camelcase, no-undef, prefer-destructuring */
__webpack_public_path__ = window.__webpack_public_path__;
